// @flow
import React from 'react';
import classNames from 'classnames';
import { t } from 'javascripts/utils/withTranslation';
import Icon from '../../../_particles/icon/react/Icon';
import type { NavigationItem, NavigationSubItem } from '../types';

const ItemChildren = ({
  item,
  index,
}: {
  item: NavigationSubItem,
  index: number,
}): React$MixedElement => (
  <li key={index} className="burger-d__list-item">
    <a
      href={item.link}
      className={classNames(
        'burger-d__link',
        item.target === '_blank' && 'link--external',
        item.active &&
          item.children?.filter((i) => i.active === 1).length <= 0 &&
          'burger-d__link--active',
        item.current && 'burger-d__link--current'
      )}
      target={item.target && item.target !== '' ? item.target : null}
    >
      <span className="burger-d__link-text">{item.title}</span>
    </a>

    {item.children && item.children.length > 0 && (
      <ul className="burger-d__sub">
        {item.children.map((subItem, subIndex) => (
          <ItemChildren key={subIndex} item={subItem} index={subIndex} />
        ))}
      </ul>
    )}
  </li>
);

const ItemGrid = ({
  item,
  modifier,
}: {
  item?: NavigationItem | null,
  modifier: string,
}): React$MixedElement => (
  <div className="burger-d__grid">
    {item && (
      <a
        href={item.link}
        target={item.target && item.target !== '' ? item.target : null}
        className="burger-d__overview"
      >
        <h2
          className="headline headline--6 burger-d__headline"
          id={`burger-item--${modifier}`}
        >
          <span>{item.title}</span>
        </h2>
        <span className="burger-d__icon">
          <Icon icon="arrow-right-line" />
        </span>
      </a>
    )}
    {item?.children && item.children.length > 0 && (
      <div className="burger-d__list">
        {item.children.map((col, colIndex) => (
          <ul
            key={colIndex}
            className={classNames(
              'burger-d__col',
              `burger-d__col--${colIndex + 1}`
            )}
          >
            {col.map((subItem: NavigationSubItem, subIndex) => (
              <ItemChildren key={subIndex} item={subItem} index={subIndex} />
            ))}
          </ul>
        ))}
      </div>
    )}
  </div>
);

export default ItemGrid;
